import { render, staticRenderFns } from "./NuevaClasificacionVentas.vue?vue&type=template&id=2a63d4bb"
import script from "./NuevaClasificacionVentas.vue?vue&type=script&lang=js"
export * from "./NuevaClasificacionVentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports